module.exports = __webpack_public_path__ + "img/51626531.aea1aaab.png";